function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { themeState } from '../theme';
import { optionsState } from '../options';
import { Entry } from './Entry';
const style = {
  listStyleType: 'none',
  margin: 0,
  padding: 0
};
export function Tree(_ref) {
  var _Object$keys$length;

  let {
    data,
    depth,
    ...props
  } = _ref;
  const {
    fontSize,
    tabWidth
  } = useRecoilValue(themeState);
  const {
    displayEntriesMaxCount
  } = useRecoilValue(optionsState);
  const [truncate, toggleTruncate] = useState(true);
  const entries = useMemo(() => {
    const list = Object.entries(data !== null && data !== void 0 ? data : {});
    return displayEntriesMaxCount > 0 && truncate && list.length > displayEntriesMaxCount ? list.slice(0, displayEntriesMaxCount) : list;
  }, [data, truncate, displayEntriesMaxCount]);
  const size = (_Object$keys$length = Object.keys(data !== null && data !== void 0 ? data : {}).length) !== null && _Object$keys$length !== void 0 ? _Object$keys$length : 0;
  return /*#__PURE__*/React.createElement("ol", _extends({}, props, {
    style: { ...style,
      marginLeft: fontSize * (depth === 0 ? 2 : tabWidth),
      ...props.style
    }
  }), entries.map(_ref2 => {
    let [k, v] = _ref2;
    return /*#__PURE__*/React.createElement(Entry, {
      key: k,
      data: [k, v],
      depth: depth
    });
  }), displayEntriesMaxCount > 0 && truncate && size > displayEntriesMaxCount && /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: 'pointer'
    },
    onClick: () => toggleTruncate(false)
  }, '(', /*#__PURE__*/React.createElement("ins", null, size - displayEntriesMaxCount, " more..."), ')'));
}